module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Bucket-a37b540a77d25cd37d8b13fba3288725.svg";